import React, { useState, useEffect } from 'react';
import Axios from "axios";
import moment from 'moment';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import TeasuryTable from '../../../components/Content/TeasuryTable';
import SearchAndFilter from '../../../components/Search/SearchAndFilter';
import Pagination from '../../../components/Footer/Pagination';

import { formatDate } from "../../../../utils/DateUtils";
import { getAlert, getData, parseCurrency, updateQty } from '../../../../utils/SamuiUtils';
import { manageWhItemData } from '../../../../utils/WarehouseUtils';
import { getReport } from '../../../../utils/ReportUtils';

// Keyboard Navigation
import { useDataTableKeyboardNavigation, getDataTableRowStyle, getDataTableKeyboardInstructions } from '../../../../utils/DataTableKeyboardNavigation';

const Main = ({ name, dataMasterList, dataDetailList, onPageInsert, callInitialize }) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [whDocId, setWhDocId] = useState("");
  const [whDocNo, setWhDocNo] = useState("");
  const [whDocStatus, setWhDocStatus] = useState("");
  const [customerName, setCustomerName] = useState("");

  const [showModal, setShowModal] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(
    localStorage.getItem('currentPage') ? parseInt(localStorage.getItem('currentPage')) : 1
  );
  const [itemsPerPage, setItemsPerPage] = useState(
    localStorage.getItem('itemsPerPageDropdown') ? parseInt(localStorage.getItem('itemsPerPageDropdown')) : 10
  );

  // Search and filter states
  const [searchTerm, setSearchTerm] = useState(
    localStorage.getItem('searchTerm') || ''
  );
  const [filteredItems, setFilteredItems] = useState([]);

  // Date filter states
  const [startDate, setStartDate] = useState(() => {
    const storedStartDate = localStorage.getItem('startDate');
    return storedStartDate || moment().startOf('month').format('YYYY-MM-DD');
  });

  const [endDate, setEndDate] = useState(() => {
    const storedEndDate = localStorage.getItem('endDate');
    return storedEndDate || moment().endOf('month').format('YYYY-MM-DD');
  });

  // Keyboard navigation
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);

  // Field mappings for keyboard navigation
  const fieldMappings = {
    WHDoc_Id: 'WHDoc_Id'
  };

  const onRowSelected = (fromData) => {
    // พี่คินอยากให้กระพริบ เดี๋ยวไปร์ทจัดให้
    setFilteredDetailList([]);
    setWhDocNo("");

    setTimeout(() => {
      const filteredDetail = dataDetailList.filter(data => parseCurrency(data.WHDoc_Id) === fromData.WHDoc_Id);

      if (filteredDetail && filteredDetail.length > 0) {
        setFilteredDetailList(filteredDetail);
      } else {
        setFilteredDetailList([]);
      }

      setWhDocId(fromData.WHDoc_Id);
      setWhDocNo(fromData.WHDoc_No);
      setWhDocStatus(fromData.WHDoc_Status);
      setCustomerName(fromData.T_WH_NAME_CHECKDOCTYPE);
    }, 50);
  };

  const handleCancel = async () => {
    try {
      setShowModal(false);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wh_doc_no: whDocNo,
        wh_doc_status: parseCurrency("13", 10),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-wh-doc-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // คืนของในคลัง จาก ใบส่ง
      const findMasterList = await getData("WHDoc_H", `WHDoc_Id = '${whDocId}'`);
      const findDetailList = await getData("WHDoc_D", `WHDoc_Id = ${whDocId}`);
      if (findMasterList && findMasterList.length > 0 && findDetailList && findDetailList.length > 0) {
        const master = findMasterList[0];

        for (const itemDetail of findDetailList) {
          // #####################################
          // เอาออกจากคลังตามจำนวนสินค้าที่ใบขาย
          // #####################################
          await manageWhItemData(
            itemDetail.Item_Id, // Item ไอดีของสิ่งนั้นๆ
            itemDetail.Item_Code, // Item โค้ดของสิ่งนั้นๆ
            itemDetail.Item_Name, // ชื่อ Item นั้นๆ
            master.F_WH_Id, // WarehouseID ของไอเทม
            "AI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            parseCurrency(itemDetail.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
            whDocId, // ไอดีเอกสาร
            whDocNo, // เลขเอกสาร
            whDocNo, // เลขเอกสารอ้างอิง
            "ยกเลิกใบส่งสินค้า" // หมายเหตุ
          );

          // ตรวจสอบข้อมูลการรับสินค้าจากใบขาย
          let findSoDetail = await getData(
            "SO_D",
            `Doc_ID = ${master.Ref_DocID} AND Item_Id = ${itemDetail.Item_Id}`
          );

          if (findSoDetail && findSoDetail.length > 0) {
            let itemRecQtyOld = parseCurrency(findSoDetail[0].Item_Rec_Qty) || 0;
            let itemDecreaseQty = parseCurrency(itemDetail.Item_Qty) || 0;

            // ถ้ามีการยกเลิกหรือย้อนคืน
            let newQty = itemRecQtyOld - itemDecreaseQty;  // ลดจำนวนรับ

            // update ค่าใหม่
            await updateQty(
              "SO_D",
              `Item_Rec_Qty = ${newQty}`,
              `WHERE Doc_ID = ${master.Ref_DocID} AND Item_Id = ${itemDetail.Item_Id}`
            );
          }
        }

        // บังคับย้อนสถานะไปเลย เพราะว่ายกเลิกเพื่อลบยอดรับสินค้าอยู่แล้ว
        await updateQty(
          "SO_H",
          `Doc_Status_Transport = '1'`,
          `WHERE Doc_ID = ${master.Ref_DocID}`
        );
      }

      setFilteredDetailList([]);
      setWhDocNo("");
      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  // Initialize data
  useEffect(() => {
    if (dataMasterList && dataMasterList.length > 0) {
      setCurrentPage(1);
      setSelectedRowIndex(0); // Reset selected row when data changes
      filterItems();
    } else {
      setFilteredItems([]);
    }
  }, [dataMasterList]);

  // Filter when search term or dates change
  useEffect(() => {
    setCurrentPage(1);
    setSelectedRowIndex(0); // Reset selected row when filters change
    filterItems();
    localStorage.setItem('searchTerm', searchTerm);
    localStorage.setItem('startDate', startDate);
    localStorage.setItem('endDate', endDate);
  }, [searchTerm, startDate, endDate, dataMasterList]);

  // Filter items function
  const filterItems = () => {
    try {
      const start = moment(startDate, 'YYYY-MM-DD').startOf('day');
      const end = moment(endDate, 'YYYY-MM-DD').endOf('day');

      let filtered = (dataMasterList || []).filter((item) => {
        if (item.WHDoc_Date == null || item.WHDoc_Date === '') return false;
        const itemDate = moment(item.WHDoc_Date);
        if (!itemDate.isValid()) return false;
        return itemDate.isBetween(start, end, null, '[]');
      });

      if (searchTerm.trim() !== '') {
        const term = searchTerm.toLowerCase();
        filtered = filtered.filter((item) =>
          (item.WHDoc_No && item.WHDoc_No.toLowerCase().includes(term)) ||
          (item.T_WH_NAME_CHECKDOCTYPE && item.T_WH_NAME_CHECKDOCTYPE.toLowerCase().includes(term)) ||
          (item.T_WH_Name && item.T_WH_Name.toLowerCase().includes(term)) ||
          (item.Picking_No && item.Picking_No.toLowerCase().includes(term))
        );
      }

      setFilteredItems(filtered);
    } catch (error) {
      console.error('Filter error:', error.message);
      setFilteredItems([]);
    }
  };

  // Pagination calculations
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSelectedRowIndex(0); // Reset selected row when page changes
    localStorage.setItem('currentPage', pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Keyboard navigation
  useDataTableKeyboardNavigation(
    true, // isActive
    currentItems,
    selectedRowIndex,
    setSelectedRowIndex,
    (selectedItem) => {
      setSelectedRowIndex(currentItems.findIndex(item => item.WHDoc_Id === selectedItem.WHDoc_Id));
      onRowSelected(selectedItem);
    },
    fieldMappings,
    currentPage,
    handlePageChange,
    filteredItems.length,
    itemsPerPage,
    getReport, // getReport function
    {
      customKeyHandlers: {
        'Enter': (event, { selectedRowIndex, currentItems }) => {
          event.preventDefault();
          if (currentItems && currentItems[selectedRowIndex]) {
            onRowSelected(currentItems[selectedRowIndex]);
          }
        },
        'p': (event, { selectedRowIndex, currentItems }) => {
          event.preventDefault();
          if (currentItems && currentItems[selectedRowIndex]) {
            getReport('pd', currentItems[selectedRowIndex].WHDoc_No);
          }
        },
        'P': (event, { selectedRowIndex, currentItems }) => {
          event.preventDefault();
          if (currentItems && currentItems[selectedRowIndex]) {
            getReport('pd', currentItems[selectedRowIndex].WHDoc_No);
          }
        },
        'F5': (event) => {
          event.preventDefault();
          const searchInput = document.querySelector('input[type="text"]');
          if (searchInput) {
            searchInput.focus();
          }
        },
        'Escape': (event) => {
          event.preventDefault();
          setSearchTerm('');
        }
      }
    }
  );

  // ทดสอบการทำค้นหาโดย SpriteZadis (ยังไม่สมบูรณ์ เดี๋ยวมาทำต่อ)
  const [searchItemTerm, setSearchItemTerm] = useState('');

  return <>
    <Breadcrumbs page={name} items={[
      { name: 'ขายสินค้า', url: '/sellproducts' },
      { name: name, url: '/product-delivery' },
    ]} />
    <div className="container-fluid card py-3 hidden-scrollbar" style={{ maxHeight: "80vh", overflowY: "auto" }}>
      {/* Search and Filter Section */}
      <SearchAndFilter
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        searchPlaceholder="ค้นหาเลขเอกสาร, ลูกค้า..."
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        showDateFilter={true}
        onAddNew={onPageInsert}
        addButtonText={`สร้าง${name}`}
        showAddButton={true}
      />
      <hr />
      <div className="row ">
        <div className="col-6 mb-1" style={{ borderRight: '2px solid #c7c8c9' }}>
          <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
            <table id="basic-datatables" className="table table-striped table-hover">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '15%' }}>วันที่</th>
                  <th className="text-center" style={{ width: '15%' }}>เลขเอกสาร</th>
                  <th className="text-center" style={{ width: '55%' }}>ลูกค้า</th>
                  <th className="text-center" style={{ width: '10%' }}>สถานะ</th>
                  <th className="text-center" style={{ width: '5%' }}>พิมพ์</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.length > 0 ? (
                  currentItems.map((data, index) => (
                    <tr
                      key={data.WHDoc_Id || index + 1}
                      onClick={() => {
                        setSelectedRowIndex(index);
                        onRowSelected(data);
                      }}
                      style={{
                        cursor: 'pointer',
                        ...getDataTableRowStyle(index, selectedRowIndex)
                      }}>
                      <td className="text-center">{formatDate(data.WHDoc_Date)}</td>
                      <td className="text-center">{data.WHDoc_No}</td>
                      <td className="text-left">{data.T_WH_NAME_CHECKDOCTYPE}</td>
                      <td className="text-center">
                        <button
                          className="btn"
                          style={{
                            backgroundColor: data.WHDocStatus_Colour,
                            color: 'white',
                            width: '100%',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {data.WHDocStatus_Name.includes("อนุมัติ") ? "ปกติ" : data.WHDocStatus_Name}
                        </button>
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-link btn-sm px-3"
                          onClick={(e) => {
                            e.stopPropagation();
                            (async () => {
                              try {
                                await getReport('pd', data.WHDoc_No);
                              } catch (e) {
                                console.error(e);
                              } finally {
                                await callInitialize();
                              }
                            })();
                          }}
                        >
                          {(() => {
                            const isPrinted = String(data.Printed_Status || "").toUpperCase() === 'Y';
                            return (
                              <i
                                className="fa fa-print"
                                style={{ fontSize: "16px", color: isPrinted ? '#13A10E' : 'rgb(13,110,253)' }}
                              ></i>
                            );
                          })()}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <center>
                        <h5>ไม่พบข้อมูล</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination & Items per page selector */}
          <div className="bg-white mt-2" style={{ padding: '8px 0' }}>
            <div className="row m-0">
              <div className="col-12 d-flex justify-content-between align-items-center flex-wrap py-2">
                <div className="d-flex align-items-center flex-wrap">
                  <span className="me-2">แสดง:</span>
                  <select
                    className="form-select me-2"
                    style={{ width: 'auto', minWidth: '70px' }}
                    value={itemsPerPage}
                    onChange={(e) => {
                      const newItemsPerPage = parseInt(e.target.value);
                      setItemsPerPage(newItemsPerPage);
                      localStorage.setItem('itemsPerPageDropdown', newItemsPerPage);
                      setCurrentPage(1);
                      setSelectedRowIndex(0);
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                  <span>รายการต่อหน้า | แสดง {indexOfFirstItem + 1} ถึง {Math.min(indexOfLastItem, filteredItems.length)} จาก {filteredItems.length} รายการ</span>
                </div>
                <div className="d-flex align-items-center flex-wrap">
                  <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    itemsPerPage={itemsPerPage}
                    dataMasterList={filteredItems}
                    handlePageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-6 mb-3">
          <div className="d-flex align-items-center bg-light p-3 rounded shadow-sm position-relative">
            <div className="flex-grow-1 text-start position-relative">
              <p className="card-title mb-0 fw-bold">
                เอกสารเลขที่: <span className="text-primary fw-bold fs-4">{whDocNo}</span>
              </p>
              <p className="mb-0">
                ชื่อลูกค้า: <span className="fw-semibold">{customerName}</span>
              </p>
            </div>
            {whDocNo && (
              <>
                <button
                  type="button"
                  className="btn btn-danger ms-auto"
                  onClick={() => setShowModal(true)}
                  disabled={parseCurrency(whDocStatus) === 13}
                >
                  ยกเลิกใบส่งสินค้า
                </button>
              </>
            )}
          </div>
          <TeasuryTable dataList={filteredDetailList} />
        </div>
        {/* Modal สำหรับ Confirm ว่าจะยกเลิกใบส่งไหม */}
        <div className={`modal fade ${showModal ? 'show' : ''}`} tabIndex="-1" style={{ display: showModal ? 'block' : 'none' }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">ยืนยันการยกเลิกใบส่งสินค้า</h5>
              </div>
              <div className="modal-body">
                <p>คุณแน่ใจว่าต้องการยกเลิกใบส่งสินค้านี้?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-lg w-25 shadow text-white"
                  style={{
                    backgroundColor: '#EF6C00',
                    fontSize: '16px',
                    position: 'relative',
                    whiteSpace: 'nowrap'
                  }}
                  onClick={() => handleCancel()}
                >
                  ยืนยัน
                </button>
                <button
                  type="button"
                  className="btn btn-lg w-25 shadow text-white"
                  style={{ backgroundColor: 'red', fontSize: '16px' }}
                  onClick={() => setShowModal(false)}
                >
                  ยกเลิก
                </button>
              </div>
            </div>
          </div>
        </div>
      </div >

      {/* Keyboard Instructions */}
      <div className="container-fluid mt-2">
        <div className="row">
          <div className="col-12">
            <small className="text-muted">
              {getDataTableKeyboardInstructions()}
            </small>
          </div>
        </div>
      </div>
    </div >
  </>;
};

export default Main;